import { HttpClient } from '@adapters/HttpClient';
import { Client } from '../models/Clients';

export interface ClientsFilters {
  searchFilter?: { filters: any[]; logic: string };
  sortBy?: string;
  sortDirection?: 'asc' | 'desc';
  page?: number;
  limit?: number;
  /** Filtrar hijos del equipo padre (GET /teams-child?parent_team_id=...) */
  parent_team_id?: number;
  /** Búsqueda por nombre (GET /teams-child?name=...) */
  name?: string;
  country?: string;
  verified?: boolean;
  type?: string;
  /** Filtrar por origen del cliente (GET /teams-child?customer_origins=organic,affiliate) */
  customer_origins?: string[];
}

export interface ClientsPage {
  clients: Client[];
  nextPage?: number;
  hasMore: boolean;
  total: number;
}

function buildAdvancedFiltersParams(searchFilter: { filters: any[]; logic: string }) {
  const params: Record<string, any> = {};
  if (searchFilter.filters && Array.isArray(searchFilter.filters)) {
    searchFilter.filters.forEach((f, i) => {
      params[`advanced_filters[filters][${i}][column]`] = f.column;
      params[`advanced_filters[filters][${i}][operator]`] = f.operator;
      if (f.value !== undefined && f.value !== null && !(Array.isArray(f.value) && f.value.length === 0)) {
        params[`advanced_filters[filters][${i}][value]`] = f.value;
      }
    });
  }
  if (searchFilter.logic) {
    params['advanced_filters[logic]'] = searchFilter.logic;
  }
  return params;
}

export class ClientsApiAdapter {
  constructor(private httpClient: HttpClient) {}

  async getClientsPaginated(filters: ClientsFilters = {}): Promise<ClientsPage> {
    const {
      searchFilter,
      sortBy = 'id',
      sortDirection = 'desc',
      page = 1,
      limit = 20,
      parent_team_id,
      name,
      country,
      verified,
      type,
      customer_origins,
    } = filters;

    const params: any = {
      ...(sortBy && { 'sorting[column]': sortBy }),
      ...(sortDirection && { 'sorting[direction]': sortDirection }),
      page,
      per_page: limit,
      ...(parent_team_id !== undefined && { parent_team_id }),
      ...(name !== undefined && name.trim() !== '' && { name: name.trim() }),
      ...(country && { country }),
      ...(verified !== undefined && { verified }),
      ...(type && { type }),
      ...(customer_origins &&
        customer_origins.length > 0 && {
          customer_origins: customer_origins.join(','),
        }),
      ...(searchFilter ? buildAdvancedFiltersParams(searchFilter) : {}),
    };

    // Solo mostrar loading global para la primera página
    const showGlobalLoading = page === 1;
    const response = await this.httpClient.get<any>('/teams-child', params, {}, showGlobalLoading);

    return {
      clients: response.data,
      nextPage: response.meta.currentPage < response.meta.lastPage ? response.meta.currentPage + 1 : undefined,
      hasMore: response.meta.currentPage < response.meta.lastPage,
      total: response.meta.total,
    };
  }

  async getAll(): Promise<Client[]> {
    const response = await this.getClientsPaginated();
    return response.clients;
  }

  async getClientById(id: number): Promise<Client> {
    const response = await this.httpClient.get<Client>(`/teams-child/${id}`);
    return response;
  }
}
